import { useEffect } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function I() {
    const { useLang } = useGlobal();
    const { t } = useLang('wave2portableairconditioner');

    useEffect(() => {
        AniContainer.create({
            syncFromTo: [['.wave2-detail-I .title-text', { y: 0, opacity: 1 }, { y: 240, opacity: 0 }]],
            triggerElement: '.wave2-detail-I .sec2 .img-box',
            triggerHook: 1,
            offset: 0,
            duration: 200,
        });
    }, []);

    return (
        <div className={`wave2-detail-I ${css.wave2DetailI}`}>
            <div className="sticky">
                <div className="sec1">
                    <div className="video-box">
                        <div className="video-inner">
                            {/* <EFVideo ref={videoRef} className="fullImgs" width="100%" height="100%" muted autoPlay={false} sources={sources} /> */}
                            <NextImage
                                webpSrc={require('@publicLocal/wave2/detail/pc/I_1.webp')}
                                src={require('@publicLocal/wave2/detail/pc/I_1.jpg')}
                                alt={t('detail.sectionB_6')}
                                aria-label={t('detail.sectionB_6')}
                            />
                        </div>
                    </div>
                    <div className="title">
                        <p className="title-text">{t('detail.sectionB_6')}</p>
                    </div>
                </div>
                <div className="sec2">
                    <div className="img-box">
                        <NextImage
                            webpSrc={require('@publicLocal/wave2/detail/pc/section_j.webp')}
                            src={require('@publicLocal/wave2/detail/pc/section_j.jpg')}
                            alt={t('detail.sectionB_3')}
                            aria-label={t('detail.sectionB_3')}
                        />
                    </div>
                    <div className="text-box">
                        <div className="text-inner">
                            <p className="desc">{t('detail.sectionJ_1')}</p>
                            <p className="note">{t('detail.sectionJ_2')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
